<template>
    <div class="c-article__related" v-if="!!communities.length">
        <h5>Related to:</h5>
        <div id="related" class="c-communities__wrapper c-communities__wrapper--article">
            <div data-cy="related-communities" class="c-communities__tile" v-for="community in communities">
                <a :href="'/' + community.url">
                    <img class="c-communities__img" :src="$simpleStore.cloudinaryUrl(210, 210, 'img/communities/' + community.community_id + '/' + community.image, $root)">
                </a>
                <div class="c-communities__name" data-cy="related-community">
                    <a :href="'/' + community.url">{{community.name}}</a>
                </div>
            </div>
        </div>
        <div class="c-article__more-btn" v-if="communities.length > 10">
            <a href="#" class="c-btn3">More</a>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            communities: []
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.$http.get('/api/v1/communities/related/' + this.$root.community.id, {}).then(response => {
                this.communities = response.data;
            }, response => {
                console.log('Errored:');
                console.log(response);
            });
        }
    }
}
</script>
